export const SAVE_ALL_INVOICES = 'SAVE_ALL_INVOICES'
export const SAVE_INVOICE = 'SAVE_INVOICE'
